import {ValidationStepConfig} from 'src/types/form';
import {FollowCollegesForm} from 'src/types/onboarding';
import {RegistrationSteps} from 'src/types/enums';
import FollowColleges from './FollowColleges';
import {noop} from 'lodash';

export default FollowColleges;

export const FollowCollegesConfig: ValidationStepConfig<FollowCollegesForm, void> = {
  key: RegistrationSteps.FOLLOW_COLLEGES,
  Component: FollowColleges,
  validate: noop,
  pathSuffix: 'follow-colleges',
  // don't display if signupSkipFollowedCollegesStep is set to true
  shouldDisplay: (form): boolean => !form.signupSkipFollowedCollegesStep,
};
